// Core imports
import * as React from 'react';
import * as moment from 'moment';
import PartClaimService from 'src/services/partClaim/partClaimService';

// Components imports
import DateSingle from 'src/components/common/DateSingle';
import Button from '../common/Button';
import Select from 'src/components/common/Select';

// Models imports
import {
  PartClaimModel,
  IWarrantyClaimDetails
} from 'src/model/partClaim.model';

// Style and misc imports
import './PartClaimForm.scss';
import { any, element } from 'prop-types';
import UserModel from 'src/model/user.model';

class PartClaimForm extends React.Component<
  IPartClaimFormProps,
  IPartClaimFormState
> {
  public PhoneNumberRegEx = new RegExp('^$|(\\+[0-9]{1,3})?[0-9]{10}$');
  public PhoneNumberDashesRegEx = new RegExp('^[0-9. ]*$');
  public emailRegEx = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$');
  public commentsRegEx = new RegExp('^[a-zA-Z0-9_. ]*$');

  constructor(props: IPartClaimFormProps) {
    super(props);

    this.state = {
      formData: {
        accountNumber: this.props?.userData?.accountId
          ? this.props.userData.accountId
          : '',
        accountName: '',
        brand: '',
        claimNumber: 0, // number
        customer: {
          address: '',
          city: '',
          country: 'US',
          firstName: '',
          lastName: '',
          phone: '',
          servicerEmail: '',
          state: '',
          zipCode: ''
        },
        customerComplaint: '',
        modelNumber: '',
        partInstalledDate: null,
        partFailedDate: null,
        serialNumber: '',
        warrantyClaimDetails: [this.partBase]
      },
      component: {
        formValidated: false,
        fieldsFailed: []
      },
      brandSelect: [],
      selectedBrand: null,
      errors: {
        servicerEmailError: false,
        customerPhoneError: false,
        partInstalledDateError: false,
        partFailDateError: false,
        partsDetailsInvalidList: [],
        accountNumberInvalidError: false,
        customerComplaintInvalidError: false
      }
    };
  }

  private partBase = {
    partNumber: '',
    quantity: 0,
    price: 0,
    referenceNumber: '',
    invoiceNumber: 0
  };

  public componentDidMount = () => {
    PartClaimService.getBrands().then((response: any) => {
      this.formatBrands(response);
    });
  };

  private formatBrands = (brands: any[]) => {
    const brandSelect = brands.map(brand => {
      return {
        value: brand.name,
        label: brand.name
      };
    });
    this.setState({ brandSelect });
  };

  /* 
    handleDataSetting: takes the name and value of input and sets it in the state
   */
  private handleDataSetting = (event: any) => {
    const { name, value } = event.target;

    if (name.includes('customer.')) {
      const customerState = { ...this.state.formData };
      const nameSplit: any = name.split('.');
      customerState.customer[nameSplit[1]] = value;
      this.setState({ formData: customerState }, () => {
        this.validateForm();
        if (nameSplit[1] === 'servicerEmail') {
          this.validateEmail();
        } else if (nameSplit[1] === 'phone') {
          this.validatePhone();
        }
      });
    } else {
      const customerState = { ...this.state.formData };
      customerState[name] = value;
      if (name === 'accountNumber') {
        const accountName = this.setAccountName(value);
        customerState['accountName'] = accountName;
      }
      this.setState({ formData: customerState }, () => {
        this.validateForm();
        if (name === 'customerComplaint') {
          this.validateComplaint();
        }
      });
    }
  };

  private setAccountName = (accountNumber: string) => {
    let name = '';
    this.props.userAccounts.map(account => {
      if (account.accountId === accountNumber) {
        name = account.name;
      }
      return;
    });
    return name;
  };

  private handlePartDataSetting = (event: any, index: number) => {
    const { name, value } = event.target;

    const customerState = { ...this.state.formData };
    const partState = { ...this.state.formData.warrantyClaimDetails[index] };
    const nameSplit: any = name.split('.');
    partState[nameSplit[1]] = value;
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    warrantyClaimDetails[index] = partState;
    this.setState(
      { formData: { ...customerState, warrantyClaimDetails } },
      () => {
        this.validateForm();
      }
    );
  };

  private setInstalledDate = (installedDate: any) => {
    const customerState = { ...this.state.formData };
    customerState.partInstalledDate = installedDate;
    this.setState(
      {
        formData: customerState
      },
      () => {
        this.validateForm();
        const errors = { ...this.state.errors };
        errors.partInstalledDateError = this.isDateInFuture(
          this.state.formData.partInstalledDate
        );
        this.setState({ errors });
      }
    );
  };

  private setFailedDate = (failedDate: any) => {
    const customerState = { ...this.state.formData };
    customerState.partFailedDate = failedDate;
    this.setState(
      {
        formData: customerState
      },
      () => {
        this.validateForm();
        const errors = { ...this.state.errors };
        errors.partFailDateError = this.isDateInFuture(
          this.state.formData.partFailedDate
        );
        this.setState({ errors });
      }
    );
  };

  /* 
    validateForm
   */
  private validateForm = () => {
    const newComponent = { ...this.state.component };
    newComponent.formValidated = true;
    newComponent.fieldsFailed = [];
    for (const property in this.state.formData) {
      if (this.state.formData.hasOwnProperty(property)) {
        if (property !== 'component') {
          if (
            property === 'claimNumber' &&
            this.state.formData.claimNumber === 0
          ) {
            this.setState({
              formData: {
                ...this.state.formData,
                claimNumber: this.props.claimNumber
              }
            });
          }
          if (
            property === 'partInstalledDate' ||
            property === 'partFailedDate'
          ) {
            if (!this.state.formData[property]) {
              newComponent.formValidated = false;
              newComponent.fieldsFailed.push(property.toString());
            }
          }
          if (typeof this.state.formData[property] === 'string') {
            if (
              this.state.formData[property] === '' &&
              property !== 'accountName'
            ) {
              newComponent.formValidated = false;
              newComponent.fieldsFailed.push(property.toString());
            }
          } else if (typeof this.state.formData[property] === 'number') {
            if (
              this.state.formData[property] === 0 ||
              this.state[property] === ''
            ) {
              newComponent.formValidated = false;
              newComponent.fieldsFailed.push(property);
            }
          }
        }
      }
    }
    for (const property in this.state.formData.customer) {
      if (this.state.formData.customer.hasOwnProperty(property)) {
        if (typeof this.state.formData.customer[property] === 'string') {
          if (this.state.formData.customer[property] === '') {
            newComponent.formValidated = false;
            newComponent.fieldsFailed.push(property.toString());
          }
        } else if (typeof this.state.formData.customer[property] === 'number') {
          if (
            this.state.formData.customer[property] === 0 ||
            this.state[property] === ''
          ) {
            newComponent.formValidated = false;
            newComponent.fieldsFailed.push(property);
          }
        }
      }
    }
    this.state.formData.warrantyClaimDetails.forEach(part => {
      for (const property in part) {
        if (part.hasOwnProperty(property)) {
          if (typeof part[property] === 'string') {
            if (part[property] === '') {
              newComponent.formValidated = false;
              newComponent.fieldsFailed.push(property.toString());
            }
          } else if (typeof part[property] === 'number') {
            if (part[property] === 0 || part[property] === '') {
              newComponent.formValidated = false;
              newComponent.fieldsFailed.push(property);
            }
          }
        }
      }
    });

    this.setState({ component: newComponent });
  };

  /* 
    buildFormData
   */
  private buildFormData = () => {
    const formData: any = { ...this.state.formData };
    formData.claimNumber = this.props.claimNumber;
    formData.partFailedDate = this.state.formData.partFailedDate.format(
      'YYYY-MM-DD'
    );
    formData.partInstalledDate = this.state.formData.partInstalledDate.format(
      'YYYY-MM-DD'
    );
    return formData;
  };

  /* 
    callService
   */
  private callService = (dataForm: any) => {
    const statusObj = {
      status: false
    };
    this.props.onFailed('', statusObj);
    PartClaimService.createPartClaim(dataForm)
      .then(response => {
        this.props.onSuccess();
      })
      .catch(error => {
        if (error.response.data.status === 400 && error.response.data.message) {
          this.handleErrors(error.response.data.message);
        }
        this.props.onFailed('');
      });
  };

  /* add another part */
  private addPart = () => {
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    warrantyClaimDetails.push(this.partBase);
    this.setState(prevState => ({
      formData: { ...prevState.formData, warrantyClaimDetails }
    }));
  };

  /* remove part */
  private removePart = (index: number) => {
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    warrantyClaimDetails.splice(index, 1);
    this.setState(prevState => ({
      formData: { ...prevState.formData, warrantyClaimDetails }
    }));
  };

  private onBrandSelected = (brand: IBrand) => {
    this.setState({ selectedBrand: brand }, () => {
      const data = {
        target: { ...this.state.selectedBrand, name: 'brand' }
      };
      this.handleDataSetting(data);
    });
  };

  private handleErrors = (errData: string) => {
    // tslint:disable-next-line: prefer-const
    let errors: IFormErrors = FormErrors();
    const extractErrorDate = errData.split(';');
    errData.includes('accountNumber')
      ? (errors.accountNumberInvalidError = true)
      : (errors['accountNumberInvalidError'] = false);
    errData.includes('customer.phone')
      ? (errors.customerPhoneError = true)
      : (errors.customerPhoneError = false);
    errData.includes('partFailedDate')
      ? (errors.partFailDateError = true)
      : (errors.partFailDateError = false);
    errData.includes('partInstalledDate')
      ? (errors.partInstalledDateError = true)
      : (errors.partInstalledDateError = false);
    errData.includes('customer.servicerEmail')
      ? (errors.servicerEmailError = true)
      : (errors.servicerEmailError = false);
    errData.includes('customerComplaint')
      ? (errors.customerComplaintInvalidError = true)
      : (errors.customerComplaintInvalidError = false);
    if (errData.includes('warrantyClaimDetails')) {
      let partsErrorExtract = extractErrorDate.find(message =>
        message.includes('warrantyClaimDetails')
      );
      partsErrorExtract = partsErrorExtract.replace(/\'/gi, '');
      let partsErrorList = partsErrorExtract
        ? partsErrorExtract.trim().split(',')
        : [];
      if (
        partsErrorList.length &&
        partsErrorList[0].includes('Invalid part numbers')
      ) {
        partsErrorList.shift();
      }
      partsErrorList = partsErrorList.map(claim => claim.trim());
      errors.partsDetailsInvalidList = partsErrorList;
    }
    this.state.formData.warrantyClaimDetails.forEach(claim => {
      errors.partsDetailsInvalidList.findIndex(
        claimObj => claim.partNumber === claimObj
      ) > -1
        ? (claim.isPartNumberInvalid = true)
        : (claim.isPartNumberInvalid = false);
    });
    this.setState({ errors });
  };

  private validateEmail = () => {
    const error = !this.emailRegEx.test(
      this.state.formData.customer.servicerEmail
    );
    const errors = { ...this.state.errors };
    errors.servicerEmailError = error;
    this.setState({ errors });
  };

  private validatePhone = () => {
    const error =
      !this.PhoneNumberRegEx.test(this.state.formData.customer.phone) ||
      !this.PhoneNumberDashesRegEx.test(this.state.formData.customer.phone) ||
      this.state.formData.customer.phone.length > 12;
    const errors = { ...this.state.errors };
    errors.customerPhoneError = error;
    this.setState({ errors });
  };

  private validateComplaint = () => {
    const error = !this.commentsRegEx.test(
      this.state.formData.customerComplaint
    );
    const errors = { ...this.state.errors };
    errors.customerComplaintInvalidError = error;
    this.setState({ errors });
  };

  private isDateInFuture = (date: moment.Moment) => {
    return date.isAfter();
  };

  public isFormInvalid = (): boolean => {
    const arr = Object.keys(this.state.errors).map(
      key => this.state.errors[key]
    );
    return arr.some(value => value === true);
  };

  public render() {
    const { t } = this.props;
    const { state } = this;
    const { formData, brandSelect, selectedBrand } = state;

    return (
      <form className="rp-part-claim-form">
        <div className="form-row basic-info">
          <div className="data-input col-sm-12 col-md-3">
            <span className="label">
              {t('partClaim.accountNumber')}:<span className="required">*</span>
            </span>
            <input
              className={
                this.state.errors?.accountNumberInvalidError
                  ? 'rp-invalid-input-highlight'
                  : ''
              }
              name="accountNumber"
              type="text"
              value={formData.accountNumber}
              onChange={this.handleDataSetting}
            />
            <span className="input-info">
              {this.state.formData.accountName}
              {this.state.formData.accountName ? <br /> : ''}
              <span className="rp-warranty-input-error-internal">
                {this.state.errors?.accountNumberInvalidError
                  ? 'Invalid account number.'
                  : ''}
              </span>
            </span>
          </div>
          <div className="data-input col-sm-12 col-md-3">
            <span className="label">
              {t('partClaim.brand')}:<span className="required">*</span>
            </span>
            <Select
              renderClass={`general-input ${selectedBrand ? 'active' : ''}`}
              options={brandSelect}
              optionsShown={4}
              width={'126px'}
              height={'40px'}
              activeOption={selectedBrand}
              isLoading={false}
              onSelected={option => {
                this.onBrandSelected(option);
              }}
              placeholder="Select brand"
            />
          </div>
          <div className="data-input col-sm-12 col-md-3">
            <span className="label">
              {t('partClaim.modelNumber')}:<span className="required">*</span>
            </span>
            <input
              className=""
              name="modelNumber"
              type="text"
              value={formData.modelNumber}
              onChange={this.handleDataSetting}
            />
          </div>
          <div className="data-input col-sm-12 col-md-3">
            <span className="label">
              {t('partClaim.serialNumber')}:<span className="required">*</span>
            </span>
            <input
              className=""
              name="serialNumber"
              type="text"
              value={formData.serialNumber}
              onChange={this.handleDataSetting}
            />
          </div>
        </div>

        <div className="form-row basic-info">
          <div className="data-input col-sm-12 col-md-6">
            <span className="label">
              {t('partClaim.servicerEmail')}:<span className="required">*</span>
            </span>
            <input
              className={
                this.state.errors?.servicerEmailError
                  ? 'rp-invalid-input-highlight'
                  : ''
              }
              name="customer.servicerEmail"
              type="text"
              value={formData.customer.servicerEmail}
              onChange={this.handleDataSetting}
            />
            <span className="rp-warranty-input-error">
              {this.state.errors?.servicerEmailError
                ? 'Invalid email format.'
                : ''}
            </span>
          </div>
        </div>

        <span className="separator" />

        <div className="form-row customer-data">
          {/* Name */}
          <div className="form-row customer-name">
            <div className="data-input col-sm-12 col-md-6">
              <span className="label">
                {t('partClaim.customerFirstName')}:
                <span className="required">*</span>
              </span>
              <input
                className=""
                name="customer.firstName"
                type="text"
                value={formData.customer.firstName}
                onChange={this.handleDataSetting}
              />
            </div>
            <div className="data-input col-sm-12 col-md-6">
              <span className="label">
                {t('partClaim.customerLastName')}:
                <span className="required">*</span>
              </span>
              <input
                className=""
                name="customer.lastName"
                type="text"
                value={formData.customer.lastName}
                onChange={this.handleDataSetting}
              />
            </div>
          </div>
          {/* Address */}
          <div className="form-row">
            <div className="data-input col-12">
              <span className="label">
                {t('partClaim.customerAddress')}:
                <span className="required">*</span>
              </span>
              <input
                className=""
                name="customer.address"
                type="text"
                value={formData.customer.address}
                onChange={this.handleDataSetting}
              />
            </div>
          </div>
          {/* Country and state */}
          <div className="form-row">
            <div className="data-input col-sm-12 col-md-6">
              <span className="label">
                {t('partClaim.customerCountry')}:
                <span className="required">*</span>
              </span>
              <span>US</span>
            </div>
            <div className="data-input col-sm-12 col-md-6">
              <span className="label">
                {t('partClaim.customerState')}:
                <span className="required">*</span>
              </span>
              <input
                className=""
                name="customer.state"
                type="text"
                value={formData.customer.state}
                onChange={this.handleDataSetting}
              />
            </div>
          </div>
          {/* City and zip */}
          <div className="form-row">
            <div className="data-input col-sm-12 col-md-6">
              <span className="label">
                {t('partClaim.customerCity')}:
                <span className="required">*</span>
              </span>
              <input
                className=""
                name="customer.city"
                type="text"
                value={formData.customer.city}
                onChange={this.handleDataSetting}
              />
            </div>
            <div className="data-input col-sm-12 col-md-6">
              <span className="label">
                {t('partClaim.customerZip')}:<span className="required">*</span>
              </span>
              <input
                className=""
                name="customer.zipCode"
                type="text"
                value={formData.customer.zipCode}
                onChange={this.handleDataSetting}
              />
            </div>
          </div>
          {/* Phone */}
          <div className="form-row">
            <div className="data-input col-sm-12 col-md-6">
              <span className="label">
                {t('partClaim.customerPhone')}:
                <span className="required">*</span>
              </span>
              <input
                className={
                  this.state.errors?.customerPhoneError
                    ? 'rp-invalid-input-highlight'
                    : ''
                }
                name="customer.phone"
                type="text"
                value={formData.customer.phone}
                onChange={this.handleDataSetting}
              />
              <span className="input-info">
                {`(${t('partClaim.noDashes')})`}
                {this.state.errors?.customerPhoneError ? (
                  <React.Fragment>
                    <br />{' '}
                    <span className="rp-warranty-input-error-internal">
                      {this.state.errors?.customerPhoneError
                        ? 'Invalid phone number.'
                        : ''}
                    </span>
                  </React.Fragment>
                ) : (
                  ''
                )}
              </span>
            </div>
          </div>
        </div>

        <span className="separator" />

        <div className="form-row part-data">
          {/* Parts installed and dates */}
          <div className="form-row">
            <div className="data-input col-sm-12 col-md-6">
              <span className="label">
                {t('partClaim.datePartsInstalled')}:
                <span className="required">*</span>
              </span>
              <div
                className={
                  this.state.errors?.partInstalledDateError
                    ? 'rp-invalid-input-highlight date-range-container'
                    : 'date-range-container'
                }
              >
                <DateSingle
                  onDateSelected={this.setInstalledDate}
                  date={formData.partInstalledDate}
                />
              </div>
              <span className="rp-warranty-input-error">
                {this.state.errors?.partInstalledDateError
                  ? 'Invalid date.'
                  : ''}
              </span>
            </div>
            <div className="data-input col-sm-12 col-md-6">
              <span className="label">
                {t('partClaim.datePartsFailed')}:
                <span className="required">*</span>
              </span>
              <div
                className={
                  this.state.errors?.partFailDateError
                    ? 'rp-invalid-input-highlight date-range-container'
                    : 'date-range-container'
                }
              >
                <DateSingle
                  onDateSelected={this.setFailedDate}
                  date={formData.partFailedDate}
                />
              </div>
              <span className="rp-warranty-input-error">
                {this.state.errors?.partFailDateError ? 'Invalid date.' : ''}
              </span>
            </div>
          </div>
          {/* Email and phone */}
          <div className="form-row">
            <div className="data-input col-12">
              <span className="label">
                {t('partClaim.customerComplaint')}:
                <span className="required">*</span>
              </span>
              <textarea
                className={
                  this.state.errors?.customerComplaintInvalidError
                    ? 'rp-invalid-input-highlight'
                    : ''
                }
                name="customerComplaint"
                value={formData.customerComplaint}
                onChange={this.handleDataSetting}
              />
              <span className="input-info">
                {`(${t('partClaim.noSymbols')})`}
                {this.state.errors?.customerComplaintInvalidError ? (
                  <React.Fragment>
                    <br />{' '}
                    <span className="rp-warranty-input-error-internal">
                      Invalid complaint format.
                    </span>
                  </React.Fragment>
                ) : (
                  ''
                )}
              </span>
            </div>
          </div>
          <div className="form-row warranty-type">
            <p>
              <span className="type">
                <strong>{t('partClaim.warrantyType')}:</strong>
                {t('partClaim.parts')}
              </span>
              <span className="service">
                <strong>{t('partClaim.servicePerformed')}:</strong>
                {t('partClaim.partsReplaced')}
              </span>
            </p>
          </div>
          <div className="form-row warranty-explanation">
            <p>
              <span className="warranty-explanation">
                <strong>{`${t('partClaim.serviceExplanation')}`}</strong>{' '}
                {t('partClaim.partReplaced')}
              </span>
            </p>
          </div>
        </div>

        <span className="separator" />

        <div className="form-row part-details">
          <div className="form-row part-details-header">
            <h1>{t('partClaim.partClaimDetails')}</h1>
            <span className="input-info">{`(${t(
              'partClaim.noCurrencySymbol'
            )})`}</span>
          </div>
          {state.formData.warrantyClaimDetails.map((part, i) => (
            <div className="form-row" key={i}>
              <div className="data-input custom-cols">
                <span className="label">
                  {t('partClaim.partNumber')}({i + 1}):
                  <span className="required">*</span>
                </span>
                <input
                  className={
                    part.isPartNumberInvalid ? 'rp-invalid-input-highlight' : ''
                  }
                  name="part.partNumber"
                  type="text"
                  value={part.partNumber}
                  onChange={e => this.handlePartDataSetting(e, i)}
                />

                <span className="rp-warranty-input-error">
                  {part.isPartNumberInvalid ? 'Invalid part number.' : ''}
                </span>
              </div>
              <div className="data-input custom-cols">
                <span className="label">
                  {t('partClaim.quantity')}:<span className="required">*</span>
                </span>
                <input
                  className=""
                  name="part.quantity"
                  type="number"
                  min={1}
                  value={Math.abs(part.quantity).toFixed(0)}
                  onChange={e => this.handlePartDataSetting(e, i)}
                />
              </div>
              <div className="data-input custom-cols">
                <span className="label">
                  {t('partClaim.price')}:<span className="required">*</span>
                </span>
                <input
                  className=""
                  name="part.price"
                  type="number"
                  min={0}
                  value={Math.abs(part.price).toString()}
                  onChange={e => this.handlePartDataSetting(e, i)}
                />
              </div>
              <div className="data-input custom-cols">
                <span className="label">
                  {t('partClaim.referenceNumber')}:
                  <span className="required">*</span>
                </span>
                <input
                  className=""
                  name="part.referenceNumber"
                  type="text"
                  value={part.referenceNumber}
                  onChange={e => this.handlePartDataSetting(e, i)}
                />
              </div>
              <div className="data-input custom-cols">
                <span className="label">
                  {t('partClaim.invoiceNumber')}:
                  <span className="required">*</span>
                </span>
                <input
                  className=""
                  name="part.invoiceNumber"
                  type="number"
                  min={1}
                  value={Math.abs(part.invoiceNumber).toFixed(0)}
                  onChange={e => this.handlePartDataSetting(e, i)}
                />
              </div>
              {state.formData.warrantyClaimDetails.length > 1 && (
                <div className="rp-delete">
                  <button
                    className="primary-button"
                    onClick={e => {
                      e.preventDefault();
                      this.removePart(i);
                    }}
                  >
                    <span className="rpds-close" />
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="data-row buttons">
          <Button
            label={t('partClaim.addPart')}
            buttonClass="primary-custom-button add-button"
            textTransform="uppercase"
            action={this.addPart}
          />
          <Button
            label={t('partClaim.submitClaim')}
            buttonClass="primary-custom-button submit-button"
            textTransform="uppercase"
            disabled={
              !this.state.component.formValidated || this.isFormInvalid()
            }
            action={() => {
              this.callService(this.buildFormData());
            }}
          />
        </div>
      </form>
    );
  }
}

export default PartClaimForm;

interface IPartDetails {
  partNumber: string;
  quantity: number;
  price: number;
  referenceNumber: string;
  invoiceNumber: number;
  isPartNumberInvalid?: boolean;
}

export interface IPartClaimFormProps {
  t: any;
  claimNumber: number;
  userAccounts: IAccount[];
  onSuccess(): void;
  onFailed(message: string, statusObj?: any): void;
  userData: UserModel;
}

interface IPartClaimFormState {
  formData: {
    accountNumber: string;
    accountName: string;
    brand: string;
    claimNumber: number;
    modelNumber: string;
    serialNumber: string;
    customer: {
      address: string;
      city: string;
      zipCode: string;
      country: string;
      firstName: string;
      lastName: string;
      servicerEmail: string;
      phone: string;
      state: string;
    };
    partInstalledDate: moment.Moment;
    partFailedDate: moment.Moment;
    customerComplaint: string;
    warrantyClaimDetails: IPartDetails[];
  };
  component: {
    formValidated: boolean;
    fieldsFailed: string[];
  };
  brandSelect: IBrand[];
  selectedBrand: IBrand;
  errors?: IFormErrors;
}

interface IBrand {
  value: any;
  label: string;
}

interface IAccount {
  accountId: string;
  name: string;
  email: string;
}

interface IFormErrors {
  servicerEmailError: boolean;
  customerPhoneError: boolean;
  partInstalledDateError: boolean;
  partFailDateError: boolean;
  // tslint:disable-next-line: array-type
  partsDetailsInvalidList: Array<string>;
  accountNumberInvalidError: boolean;
  customerComplaintInvalidError: boolean;
}

function FormErrors() {
  return {
    servicerEmailError: false,
    customerPhoneError: false,
    partInstalledDateError: false,
    partFailDateError: false,
    partsDetailsInvalidList: new Array(),
    accountNumberInvalidError: false,
    customerComplaintInvalidError: false
  };
}
